/**
 * WorkflowCenterBar — the `ora • Workflow Center` strip that tops every
 * full-frame takeover in the Outlook pane.
 *
 * Extracted from `InstanceDetailDrawer`, which had it inline. It is not
 * decoration: it is how the Servicer knows the pane has stopped being a list
 * and become the one thing they are doing. Any surface that takes the whole
 * frame wears it, so the run drawer and the "pick a workflow" takeover cannot
 * drift into looking like two different products (reported 2026-09-21, when
 * they did).
 *
 * Shared — no Office.js, no Remix import.
 */

export const WORKFLOW_CENTER_LABEL = "Workflow Center";

export function WorkflowCenterBar() {
  return (
    <div
      className="flex flex-shrink-0 items-center justify-center gap-2 border-b border-primary-gray-light-200 px-4 py-3"
      data-testid="launch-workflow-center"
    >
      <span className="text-lg font-normal leading-none text-primary-gray-light-700">
        ora
      </span>
      <span
        aria-hidden="true"
        className="mb-2 inline-block h-1.5 w-1.5 rounded-full bg-sunrise"
      />
      <span className="text-base font-normal text-primary-gray-light-500">
        {WORKFLOW_CENTER_LABEL}
      </span>
    </div>
  );
}

export default WorkflowCenterBar;
